<template>
  <div class="companyBox">
    <div style="margin-bottom: 20px">
      <Button style="margin-left: 10px;" type="primary" @click="employeeexport">导出</Button>
      <el-upload :action="BaseUrl + 'org/auth/documentationTemplate/upload'" :headers="headers" :on-error="handleError"
                 :on-success="handleSuccess" :show-file-list="false" multiple
                 style="display: inline-block;margin-left: 10px;">
        <Button type="primary">导入</Button>
      </el-upload>
      <span style="width:200px;color: rgba(243, 12, 1, 1);">请确保上传的文件名和格式和导出的文件一致</span>
    </div>
    <div>
      <Table :columns="columns" :data="tableData" :loading="loading" aria-describedby="" aria-hidden="true" border>
        <template slot="action" slot-scope="{ row }">
          <el-upload :action="BaseUrl + 'org/auth/documentationTemplate/upload'"
                     :data="{documentationTemplateName:row.documentationTemplateName}"
                     :headers="headers" :on-error="handleError" :on-success="handleSuccess" :show-file-list="false"
                     multiple style="display: inline-block;margin-left: 10px;">
            <Button size="small" type="text">导入
            </Button>
          </el-upload>
        </template>
        <template slot="documentationTemplateName" slot-scope="{ row }">
          <Button size="small" type="text" @click="showExport(row)">{{ row.documentationTemplateName }}
          </Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :page-size="size" :total="total" class="page_position" show-elevator show-sizer
            show-total @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {documentationTemplatePage} from "@/api/employee";

export default {
  name: "company",
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      size: 30,
      pageSize: 30,
      loading: false, // 表格等待
      btnList: [],
      formCustom: {},
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "模板名称", slot: "documentationTemplateName", key: "documentationTemplateName", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      upAction: this.$getImg + 'api/auth/file', // 上传图片网址
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
    }
  },
  components: {},
  mounted() {
    this.init()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
  },
  methods: {
    handleSuccess(response) {
      this.$message.success('导入成功')
      location.reload()
    },
    handleError(err, file) {
      if (err) {
        this.$message.error(err)
      }
    },
    // 超出限制大小
    handleMaxSize() {
      this.$message.error('所传图片不能超过2M,请重新选择')
    },
    // 验证失败钩子
    handleFormatError() {
      this.$message.error('请上传正确的图片格式，仅支持jpg，jpeg，png三种格式')
    },
    // 初始化
    init() {
      this.loading = true
      documentationTemplatePage({
        current: this.page,
        size: this.pageSize,
        ...this.formCustom
      }).then((res) => {
        this.changeData(res);
      });
    },
    handleSearch() {
      this.loading = true
      documentationTemplatePage({
        current: 1,
        size: this.pageSize,
        ...this.formCustom
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.tableData = res.data.data.records;
      this.loading = false;
    },
    // 重置
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.formCustom = {}
      // 重置查询条件会再次查询
      this.handleSearch();
    },
    setCurrent(val) {
      this.loading = true
      let data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.page = val;
      documentationTemplatePage({
        current: val,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      let data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.pageSize = val;
      documentationTemplatePage({
        current: 1,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    employeeexport() {
      axios({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `org/auth/documentationTemplate/export`,
        responseType: "blob",
        method: "get",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("getToken"),
        },
      }).then((res) => {
        this.downloadloading = false
        const link = document.createElement("a");
        const blob = new Blob([res.data], {type: "application/zip"});
        link.download = this.$moment(new Date()).format("YYYYMMDDHHmm");
        link.href = URL.createObjectURL(blob);
        link.download = '证明文件模板.zip' // 下载的文件名
        link.click();
      }).catch(error => {
        this.$message.error('导出失败');
      })
    },
    showExport(row) {
      const link = document.createElement('a');
      link.href = row.documentationTemplateUrl + '?time=' + Date.now();
      console.log(row.documentationTemplateUrl + '?time=' + Date.now())
      link.click();
    }
  }
}
</script>
<style lang="less">
.red {
  background-color: rgba(243, 12, 1, 0.48);
  color: rgb(0, 0, 0);
  padding: 8px;
}

.green {
  background-color: rgba(66, 165, 111, 0.5);
  padding: 8px;
  color: rgba(55, 55, 55);
}

.el-calendar-table td .el-calendar-day {
  padding: 0;
}

.el-calendar__header {
  display: none
}
</style>
